































































































































































































import Vue, { PropType } from "vue";
import { Table, TableColumn, Select, Option } from "element-ui";
import Receiver from "../../../../types/receivers/Receiver";
import { ValidationObserver } from "vee-validate";
import FaceDeliveryData from "../../../../types/receivers/deliveryTypes/faceReceiver/FaceDeliveryData";
import FaceB2BDeliveryData from "../../../../types/receivers/deliveryTypes/faceb2bReceiver/FaceB2BDeliveryData";
import { isFaceDeliveryData } from "../../../../types/guards/isFaceDeliveryData";
import { isFaceB2BDeliveryData } from "../../../../types/guards/isFaceB2BDeliveryData";
import { DefaultComputed, DefaultProps } from "vue/types/options";

interface DeliveryTypeSelectorOption {
  value: string;
  label: string;
}

type Methods = {
  loadDeliveryType(): void;
  validateAndUpdateReceiverDelivery(): Promise<boolean>;
  changeDeliveryType(deliveryType: string): void;
  emitDeliveryDataFormChangedEvent(): void;
};

export default Vue.extend<any, Methods, DefaultComputed, DefaultProps>({
  props: {
    receiver: {
      required: true,
      type: Object as PropType<Receiver>,
    },
  },
  components: {
    [Table.name]: Table,
    [Option.name]: Option,
    [Select.name]: Select,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      showFACe: false,
      showFACeB2B: false,
      deliveryType: this.receiver.deliveryType,
      face: {
        managingBody: "",
        processingUnit: "",
        accountingOffice: "",
      } as FaceDeliveryData,
      faceB2B: {
        dire: "",
      } as FaceB2BDeliveryData,
      deliveryTypeSelector: {
        selectedOption: "" as string,
        options: [
          { value: "FACe", label: "FACe" },
          { value: "FACeB2B", label: "FACeB2B" },
        ] as DeliveryTypeSelectorOption[],
      },
    };
  },
  computed: {
    getInvoiceData(): Receiver {
      return this.receiver;
    },
  },
  async created() {
    this.loadDeliveryType();
    this.$watch(
      "receiver",
      (receiver: Receiver) => {
        this.deliveryType = receiver.deliveryType;

        if (receiver.deliveryType === "FACe") {
          const faceDeliveryData = receiver.deliveryData as FaceDeliveryData;
          this.face.managingBody = faceDeliveryData.managingBody;
          this.face.processingUnit = faceDeliveryData.processingUnit;
          this.face.accountingOffice = faceDeliveryData.accountingOffice;
        }

        if (receiver.deliveryType === "FACeB2B") {
          const faceB2BDeliveryData =
            receiver.deliveryData as FaceB2BDeliveryData;
          this.faceb2b.dire = faceB2BDeliveryData.dire;
        }
      },
      { immediate: true }
    );
  },
  methods: {
    emitDeliveryDataFormChangedEvent(): void {
      this.$emit("receiver-delivery-data-form-dirty");
    },
    loadDeliveryType(): void {
      this.deliveryTypeSelector.selectedOption = this.deliveryType;
      if (isFaceDeliveryData(this.receiver.deliveryData)) {
        this.face = this.receiver.deliveryData;
        this.showFACe = true;
      }

      if (isFaceB2BDeliveryData(this.receiver.deliveryData)) {
        this.faceB2B = this.receiver.deliveryData;
        this.showFACeB2B = true;
      }
    },
    async validateAndUpdateReceiverDelivery(): Promise<boolean> {
      const validated = await (
        this.$refs.receiverDelivery as InstanceType<typeof ValidationObserver>
      ).validate();

      if (!validated) {
        return false;
      }

      if (this.deliveryType === "FACe") {
        this.$emit("receiver-delivery-updated", {
          deliveryType: this.deliveryType,
          deliveryData: this.face,
        });
      }
      if (this.deliveryType === "FACeB2B") {
        this.$emit("receiver-delivery-updated", {
          deliveryType: this.deliveryType,
          deliveryData: this.faceB2B,
        });
      }

      return true;
    },
    changeDeliveryType: function (deliveryType: string): void {
      if (deliveryType === "FACe") {
        this.deliveryType = "FACe";
        this.showFACe = true;
        this.showFACeB2B = false;
      }
      if (deliveryType === "FACeB2B") {
        this.deliveryType = "FACeB2B";
        this.showFACeB2B = true;
        this.showFACe = false;
      }
    },
  },
});
